import InputPage from "./input-page-container";

export default InputPage;
